<div class="tab-container">
  <div class="tab-wrapper">
    <ul class="nav nav-pills" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          [class.active]="activeTab === 'carriers'"
          type="button"
          role="tab"
          (click)="setActiveTab('carriers')"
        >
          Carriers
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          [class.active]="activeTab === 'mappings'"
          type="button"
          role="tab"
          (click)="setActiveTab('mappings')"
        >
          Carrier Marketplace Mappings
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="settings-container">
  <app-carriers-listing *ngIf="activeTab === 'carriers'"></app-carriers-listing>
  <app-carrier-marketplace-mappings-listing
    *ngIf="activeTab === 'mappings'"
  ></app-carrier-marketplace-mappings-listing>
</div>
